// src/pages/ContactPage.jsx
import React from 'react';
import { useSearchParams } from 'react-router-dom'; // 1. Importa el hook para leer parámetros
import ContactFormSection from '../components/ContactFormSection';

function ContactPage() {
  // 2. Usa el hook para obtener una forma fácil de leer los parámetros
  const [searchParams] = useSearchParams();
  
  // 3. Revisa si el parámetro 'source' es igual a 'popup-promo'
  const isFromPopup = searchParams.get('source') === 'popup-promo';

  // 4. Define el texto que quieres pre-llenar
  const prefilledSubject = "Estoy interesado en la oferta del aire acondicionado";

  return (
    <>
      {/* 5. Pasa el texto como una "prop" al formulario si el usuario viene del popup */}
      <ContactFormSection prefilledSubject={isFromPopup ? prefilledSubject : ''} />
    </>
  );
}

export default ContactPage;